import Vue from 'vue';
import VueRouter from 'vue-router';
import AboutUs from '@/view/AboutUs.vue';
import NotificationLog from '@/view/AboutUs.vue';
import Login from '../view/auth/login/index.vue';
import VerifyOtp from '../view/auth/login/otpvarification.vue';
import Profile from '../view/auth/profile/index.vue';
import { hasAuthUser, removeStorage, getAuthUser } from '@/Util/auth';
import Dashboard from '../view/auth/dashboard/index.vue';


import Integrations from '../view/admin/integrations/index.vue';
import AddIntegrations from "../view/admin/integrations/add.vue";
import UpdateIntegrations from "../view/admin/integrations/update.vue";

import Users from "../view/admin/Users/index.vue"
import AddUsers from "../view/admin/Users/add.vue"
import UpdateUsers from "../view/admin/Users/update.vue"
import ShowUser  from "../view/admin/Users/show.vue"

import scheduledTasks from "../view/admin/scheduledTasks/index.vue"
import AddScheduledTasks from "../view/admin/scheduledTasks/add.vue"
import UpdateScheduledTasks from "../view/admin/scheduledTasks/update.vue"

import TaskLogs from "../view/admin/TaskLogs/index.vue"
import AddTaskLogs from "../view/admin/TaskLogs/add.vue"
import UpdateTaskLogs from '../view/admin/TaskLogs/update.vue';

import ApiLogs from '../view/admin/ApiLogs/index.vue';
import ShowApiLogs from '../view/admin/ApiLogs/ShowApiLogs.vue';

import Office365Users from '../view/admin/Office365Users/index.vue';
import Inbox from '../view/admin/Office365Users/inbox.vue';
import selectedInbox from '../view/admin/Office365Users/selectedInbox.vue';

import SalesforceCrmUsers from '../view/admin/Salesforce/crm.vue';
import SalesforceCommunicationsCloudUsers from '../view/admin/Salesforce/CommunicationsCloud.vue';
import SalesforceFinancialServicesCloudUsers from '../view/admin/Salesforce/FinancialServicesCloud.vue';
import SalesforceNetZeroCloudUsers from '../view/admin/Salesforce/NetZeroCloud.vue';
import SalesforceAnalyticsUsers from '../view/admin/Salesforce/Analytics.vue';
import SalesforceEducationCloudUsers from '../view/admin/Salesforce/EducationCloud.vue';

import GsuitUsers from '../view/admin/GsuitUsers/index.vue';
import GSuitInbox from '../view/admin/GsuitUsers/inbox.vue';

import AuditTrail from '../view/admin/AuditTrail/index.vue';


import ForgotPassword from '../view/auth/forgot-pass/index.vue';
import ChangePassword from '../view/auth/change-pass/index.vue';

import MondayCRMContacts from "../view/admin/monday";
import SavedMondayCRMContacts from "../view/admin/monday/saved/crmContacts.vue"
import savedMondaycrmAccounts from "../view/admin/monday/saved/crmAccounts.vue"
import savedMondaycrmActivities from "../view/admin/monday/saved/crmActivities.vue"
import savedMondaycrmClientProjects from "../view/admin/monday/saved/crmClientProjects.vue"
import savedMondaycrmDeals from "../view/admin/monday/saved/crmDeals.vue"
import savedMondaycrmLeads from "../view/admin/monday/saved/crmLeads.vue"

import SAPEmployee from "../view/admin/sap";

import ZohoCrmUsers from "../view/admin/zoho/index.vue";

import ChatAi from "../view/admin/chatAi/index";

// user statistics
import statistics from "../view/admin/statistics/index.vue"
Vue.use(VueRouter);

//error
import Error from '../views/error';

const ParentComponent = {
    render(h) {
        return h('main-view');
    },
};

const routes = [
    {
        path: '/',
        redirect: '/dashboard',
        meta: {
            authRequired: false,
        },
    },

    {
        path: '/ApiLogs',
        name: 'ApiLogs',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Settings"}, { name: "API Logs"}]
        },
        component: ApiLogs,
    },

    {
        path: '/ApiLogs/:operation/:id?',
        name: 'ShowApiLogs',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Settings"}, { name: "ApiLogs", path: "/ApiLogs" }, { name: "Show API Logs"}]
        },
        component: ShowApiLogs,
    },

    {
        path: '/forgot-pass',
        name: 'ForgotPassword',
        meta: {
            authRequired: false,
        },
        component: ForgotPassword,
    },
    {
        path: '/test',
        name: 'test',
        meta: {
            authRequired: false,
        },
        component: NotificationLog,
    },

    {
        path: '/verify-otp',
        name: 'VerifyOtp',
        component: VerifyOtp
    },
    {
        path: '/changePassword',
        name: 'ChangePassword',
        meta: {
            authRequired: false,
        },
        component: ChangePassword,
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        meta: {
            authRequired: false,
        },
        component: Dashboard,
    },
    {
        path: '/dashboard',
        name: 'AdminDashboard',
        meta: {
            authRequired: false,
        },
        component: Dashboard,
    },
    {
        path: '/Audit-trail',
        name: 'AuditTrail',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Settings"}, { name: "User History"}]
        },
        component: AuditTrail,
    },

    // user
    {
        path: '/Users',
        name: 'Users',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Settings"}, { name: "Users"}]
        },
        component: Users,
    },

    {
        path: '/Users/:operation/',
        name: 'AddUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Settings"}, { name: "Users", path: "/Users" }, { name: "Add Users"}]
        },
        component: AddUsers,
    },

    {
        path: '/Users/edit/:id?',
        name: 'UpdateUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Settings"}, { name: "Users", path: "/Users" }, { name: "Update Users"}]
        },
        component: UpdateUsers,
    },
    {
        path: '/Users/show/:id?',
        name: 'ShowUser',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Settings"}, { name: "Users", path: "/Users" }, { name: "Show Users"}]
        },
        component: ShowUser,
    },

    // Integrations
    {
        path: '/integrations',
        name: 'Integrations',
        meta: { authRequired: false, breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations"}] },
        component: Integrations,
    },

    {
        path: '/chat-ai',
        name: 'ChatAi',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Rakoon Chat"}]
        },
        component: ChatAi
    },

    {
        path: '/integrations/:operation/',
        name: 'AddIntegrations',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/integrations" }, { name: "Add Integrations"}]
        },
        component: AddIntegrations,
    },

    {
        path: '/integrations/:operation/:id?',
        name: 'UpdateIntegrations',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/integrations" }, { name: "Update Integrations"}]
        },
        props: true,
        component: UpdateIntegrations
    },
    {
        path: '/Office365Users/:id?',
        name: 'Office365Users',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Office365 Users"}]
        },
        component: Office365Users,
    },
    {
        path: '/G-suitUsers/:id?',
        name: 'G-suitUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "G-suit Users"}]
        },
        component: GsuitUsers,
    },
    {
        path: '/SalesforceCrmUsers/:id?',
        name: 'SalesforceCrmUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Salesforce Crm"}]
        },
        component: SalesforceCrmUsers,
    },
    {
        path: '/SalesforceCommunicationsCloudUsers/:id?',
        name: 'SalesforceCommunicationsCloudUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Salesforce Communications Cloud"}]
        },
        component: SalesforceCommunicationsCloudUsers,
    },
    {
        path: '/SalesforceFinancialServicesCloudUsers/:id?',
        name: 'SalesforceFinancialServicesCloudUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Salesforce Financial Services Cloud"}]
        },
        component: SalesforceFinancialServicesCloudUsers,
    },
    {
        path: '/SalesforceNetZeroCloudUsers/:id?',
        name: 'SalesforceNetZeroCloudUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Salesforce Net Zero Cloud"}]
        },
        component: SalesforceNetZeroCloudUsers,
    },
    {
        path: '/SalesforceAnalyticsUsers/:id?',
        name: 'SalesforceAnalyticsUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Salesforce Analytics"}]
        },
        component: SalesforceAnalyticsUsers,
    },
    {
        path: '/SalesforceEducationCloudUsers/:id?',
        name: 'SalesforceEducationCloudUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Salesforce Education Cloud"}]
        },
        component: SalesforceEducationCloudUsers,
    },
    //ZOHO
    {
        path: '/ZohoCrmUsers/:id?',
        name: 'ZohoCrmUsers',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "ZOHO CRM"}]
        },
        component: ZohoCrmUsers,
    },
    {
        path: '/Inbox/:id?',
        name: 'Inbox',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Office365 Users", path: "/Office365Users"}, { name: "Inbox"} ]
        },
        component: Inbox,
    },
    {
        path: '/selectedInbox/:integrationId',
        name: 'selectedInbox',
        meta: {
            authRequired: false,
        },
        component: selectedInbox,
    },

    {
        path: '/GSuitInbox/:id?',
        name: 'GSuitInbox',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "G-suit Users", path: "/G-suitUsers"}, { name: "Inbox"} ]
        },
        component: GSuitInbox,
    },


    // Insights
    {
        path: '/Insights',
        name: 'scheduledTasks',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Insights"}]
        },
        props: true,
        component: scheduledTasks
    },

    {
        path: '/Insights/:operation/',
        name: 'AddScheduledTasks',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Insights", path: "/Insights" }, { name: "Add Insights"}]
        },
        props: true,
        component: AddScheduledTasks
    },

    {
        path: '/Insights/:operation/:id?',
        name: 'UpdateScheduledTasks',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Insights", path: "/Insights" }, { name: "Update Insights"}]
        },
        props: true,
        component: UpdateScheduledTasks
    },

    // Task Logs
    {
        path: '/TaskLogs',
        name: 'TaskLogs',
        meta: {
            authRequired: false,
        },
        props: true,
        component: TaskLogs
    },
    {
        path: '/TaskLogs/:operation',
        name: 'AddTaskLogs',
        meta: {
            authRequired: false,
        },
        props: true,
        component: AddTaskLogs
    },
    {
        path: '/TaskLogs/:operation/:?id',
        name: 'UpdateTaskLogs',
        meta: {
            authRequired: false,
        },
        props: true,
        component: UpdateTaskLogs
    },
    {
        path: '/monday/contacts/:id?',
        name: 'MondayCRMContacts',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Monday CRM"}]
        },
        component: MondayCRMContacts,
    },
    {
        path: '/monday/SavedMondayCRMContacts',
        name: 'SavedMondayCRMContacts',
        meta: {
            authRequired: false,
        },
        component: SavedMondayCRMContacts,
    },
    {
        path: '/monday/savedMondaycrmAccounts',
        name: 'savedMondaycrmAccounts',
        meta: {
            authRequired: false,
        },
        component: savedMondaycrmAccounts,
    },
    {
        path: '/monday/savedMondaycrmActivities',
        name: 'savedMondaycrmActivities',
        meta: {
            authRequired: false,
        },
        component: savedMondaycrmActivities,
    },
    {
        path: '/monday/savedMondaycrmClientProjects',
        name: 'savedMondaycrmClientProjects',
        meta: {
            authRequired: false,
        },
        component: savedMondaycrmClientProjects,
    },
    {
        path: '/monday/savedMondaycrmDeals',
        name: 'savedMondaycrmDeals',
        meta: {
            authRequired: false,
        },
        component: savedMondaycrmDeals,
    },
    {
        path: '/monday/savedMondaycrmLeads',
        name: 'savedMondaycrmLeads',
        meta: {
            authRequired: false,
        },
        component: savedMondaycrmLeads,
    },
    {
        path: '/sap/employees/:id?',
        name: 'SAPEmployee',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "Integrations", path: "/Integrations" }, { name: "Employees"}]
        },
        component: SAPEmployee,
    },

    {
        path: '/login',
        name: 'Login',
        meta: {
            authRequired: false,
        },
        component: Login,
    },

    {
        path: '/profile',
        name: 'Profile',
        meta: {
            authRequired: false,
        },
        component: Profile,
    },
    {
        path: '/about-menu',
        name: 'AboutUs',
        meta: {
            authRequired: false,
        },
        component: AboutUs,
    },
    // statistics
    {
        path: '/statistics',
        name: 'statistics',
        meta: {
            authRequired: false,
            breadcrumbs: [{ name: "Dashboard", path: "/" }, { name: "statistics"}]
        },
        component: statistics,
    },
    //error
    {
        path: '*',
        beforeEnter: (to, from, next) => {
            next('/404');
        },
    },
    {
        path: '/404',
        name: '404',
        component: Error,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
});

router.beforeEach(async (to, from, next) => {
    if (to.name === 'Login' || to.name === 'VerifyOtp' || to.path === '/login' || to.path === '/verify-otp' || to.name === 'ForgotPassword') {
        const isAuthenticated = await hasAuthUser();

        if (isAuthenticated) {
            return next({ name: 'Dashboard' });
        }

        return next();
    }

    const isAuthenticated = await hasAuthUser();
    const user = isAuthenticated ? getAuthUser() : null;
    const isAdmin = user?.role === 'admin';
    const isVolunteer = user?.role === 'volunteer';

    if (!isAuthenticated && to.path !== '/login') {
        return next({ name: 'Login' });
    }

    if (isAuthenticated) {
        if (!isAdmin && to.matched.some(record => record.meta.authAdminRequired)) {
            return next({ name: 'adminLogin' });
        }

        if (!isVolunteer && to.matched.some(record => record.meta.authVolunteerRequired)) {
            return next({ name: 'Login' });
        }

        if (isVolunteer && to.matched.some(record => record.meta.onlyForAdmins)) {
            return next({ name: '403' });
        }

        if (isAdmin && to.matched.some(record => record.meta.authRequired)) {
            return next({ name: '404' });
        }
    } else {
        if (
            to.matched.some(record =>
                record.meta.authRequired ||
                record.meta.authAdminRequired ||
                record.meta.authVolunteerRequired
            )
        ) {
            removeStorage('auth');
            return next({ name: 'Login' });
        }
    }

    next();
});





export default router;


